import React from 'react';

export const SquareIcon = ({
  width = 24,
  height = 24,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0001 4.66666H7.00008C5.71675 4.66666 4.66675 5.71666 4.66675 6.99999V21C4.66675 22.2833 5.71675 23.3333 7.00008 23.3333H21.0001C22.2834 23.3333 23.3334 22.2833 23.3334 21V6.99999C23.3334 5.71666 22.2834 4.66666 21.0001 4.66666ZM21.0001 21H7.00008V6.99999H21.0001V21Z"
      fill={color}
    />
  </svg>
);
